"use client";

import React from "react";
import { LoginOAuth } from "@/component/pages/login-oauth";

export const LoginPage = () => {
  return <LoginOAuth />;
};
